window.addEventListener("DOMContentLoaded", function () {
  // Check if the body has the specified ID
  if (document.body.id === "blue-light-blocking-glasses") {
    // Select the parent container of the filters
    const filtersContainer = document.querySelector(".collection__filters");

    if (filtersContainer) {
      // Find the filters based on their data-filter attributes
      const shapesFilter = filtersContainer.querySelector(
        ".collection__sidebar__group[data-filter='shapes']"
      );
      const bluelightFilter = filtersContainer.querySelector(
        ".collection__sidebar__group[data-filter='bluelight blockers']"
      );

      // Move the bluelight blockers filter below the shapes filter
      if (shapesFilter && bluelightFilter) {
        filtersContainer.insertBefore(
          bluelightFilter,
          shapesFilter.nextElementSibling
        );
      }
    }
  }
  const collectionParent = document.querySelector(
    '[data-collection-handle="blue-light-blocking-glasses"],[data-collection="blue-light-blocking-glasses"]',
    
  );

  if (collectionParent) {
    // Select all color divs within the products grid
    const colorDivs = collectionParent.querySelectorAll(
      "[data-product-grid-item] [data-color]"
    );

    colorDivs.forEach((colorDiv) => {
      // Get the value of the data-color attribute
      const colorValue = colorDiv.getAttribute("data-color");

      // Check if the color is not 'Rosa' or 'Orange skies'
      if (colorValue !== "rosa" && colorValue !== "orange skies") {
        // Hide the color div by setting `display: none`
        colorDiv.style.display = "none";

        // Alternatively, to remove the color div entirely:
        // colorDiv.remove();
      }
    });
    // Select all anchor tags inside the product grid items
    const anchorTags = collectionParent.querySelectorAll(
      "[data-product-grid-item] a"
    );

    anchorTags.forEach((anchor) => {
      anchor.addEventListener("click", function (event) {
        // Prevent default behavior of the anchor tag
        event.preventDefault();

        // Get the current URL from the href attribute
        const originalUrl = anchor.href;

        // Append the query parameter `view=blue-light-blocking-glasses`
        const url = new URL(originalUrl);
        url.searchParams.set("view", "blue-light-blocking-glasses");

        // Redirect to the modified URL
        window.location.href = url.toString();
      });
    });
  }
  const urlParams = new URLSearchParams(window.location.search);
  // if (urlParams.get("view") === "blue-light-blocking-glasses") {
  //     // Select the parent element with the attribute `data-option="Lens Color"`
  //     const lensColorParent = document.querySelector('[data-option="Lens Color"]');

  //     if (lensColorParent) {
  //         // Select all span elements with the `data-color` attribute within this parent
  //         const colorSpans = lensColorParent.querySelectorAll("[data-color]");

  //         colorSpans.forEach((span) => {
  //             // Get the value of the `data-color` attribute
  //             const colorValue = span.getAttribute("data-color");

  //             // Hide the span if its value is not `Rosa` or `Orange skies`
  //             if (colorValue !== "rosa" && colorValue !== "orange skies") {
  //                 span.style.display = "none";

  //                 // Alternatively, to completely remove the span:
  //                 // span.remove();
  //             }
  //         });
  //     }
  // }
  const collectionParentNatural = document.querySelector(
    '[data-collection-handle="natural-blue-light-filters"], [data-collection="natural-blue-light-filters"]'
  );

  if (collectionParentNatural) {
    // Select all anchor tags inside the product grid items
    const anchorTags = collectionParentNatural.querySelectorAll(
      "[data-product-grid-item] a"
    );

    anchorTags.forEach((anchor) => {
      // Modify the URL to include `view=natural-blue-light-filters`
      const originalUrl = anchor.href;
      const url = new URL(originalUrl);
      url.searchParams.set("view", "natural-blue-light-filters");

      // Update the anchor's href attribute with the modified URL
      anchor.href = url.toString();
    });
  }
  function filterLensColors(view, allowedColors) {
    if (urlParams.get("view") === view) {
      // Select the parent element with the attribute `data-option="Lens Color"`
      const lensColorParent = document.querySelector(
        '[data-option="Lens Color"]'
      );

      if (lensColorParent) {
        // Select all span elements with the `data-color` attribute within this parent
        const colorSpans = lensColorParent.querySelectorAll("[data-color]");

        colorSpans.forEach((span) => {
          // Get the value of the `data-color` attribute
          const colorValue = span.getAttribute("data-color");

          // Hide the span if its value is not in the allowed colors list
          if (!allowedColors.includes(colorValue.toLowerCase())) {
            span.style.display = "none";

            // Alternatively, to completely remove the span:
            // span.remove();
          }
        });
      }
    }
  }

  // Filter logic for "blue-light-blocking-glasses"
  filterLensColors("blue-light-blocking-glasses", ["rosa", "orange skies"]);

  // Filter logic for "natural-blue-light-filters"
  filterLensColors("natural-blue-light-filters", [
    "la vie en rose",
    "purple haze",
    "baja orange",
    "pop orange",
  ]);
  const parentElement = document.querySelector(
    '[data-collection="blue-light-blocking-glasses"]'
  );

  if (parentElement) {
    // Select all `.product-grid` elements within the parent
    const productGrids = parentElement.querySelectorAll(".product-grid");

    productGrids.forEach((productGrid) => {
      // Select all color divs inside each `.product-grid`
      const colorDivs = productGrid.querySelectorAll("[data-color]");

      colorDivs.forEach((colorDiv) => {
        // Get the value of the `data-color` attribute
        const colorValue = colorDiv.getAttribute("data-color").toLowerCase();

        // Check if the color is not 'rosa' or 'orange skies'
        if (colorValue !== "rosa" && colorValue !== "orange skies") {
          // Hide the color div by setting `display: none`
          colorDiv.style.display = "none";

          // Alternatively, remove the color div completely:
          // colorDiv.remove();
        }
      });
    });
  }
  const parentElement_ = document.querySelector(
    '[data-collection="natural-blue-light-filters"]'
  );

  if (parentElement_) {
    // Select all `.product-grid` elements within the parent
    const productGrids = parentElement_.querySelectorAll(".product-grid");

    productGrids.forEach((productGrid) => {
      // Select all color divs inside each `.product-grid`
      const colorDivs = productGrid.querySelectorAll("[data-color]");

      colorDivs.forEach((colorDiv) => {
        // Get the value of the `data-color` attribute
        const colorValue = colorDiv.getAttribute("data-color").toLowerCase();

        // Check if the color is not 'rosa' or 'orange skies'
        if (
          colorValue !== " rose" &&
          colorValue !== "la vie en rose" &&
          colorValue !== "purple haze" &&
          colorValue !== "baja orange" &&
          colorValue !== "pop orange"
        ) {
          // Hide the color div by setting `display: none`
          colorDiv.style.display = "none";

          // Alternatively, remove the color div completely:
          // colorDiv.remove();
        }
      });
    });
  }
  filterLensColors("blue-light-blocking-glasses", ["rosa", "orange skies"]);

  // Filter logic for "natural-blue-light-filters"
  filterLensColors("natural-blue-light-filters", [
    "la vie en rose",
    "purple haze",
    "baja orange",
    "pop orange",
  ]);
// List of collection handles to apply the logic
const collectionHandles = [
  "blue-light-blocking-glasses-apuma",
  "blue-light-blocking-glasses-grande",
  "blue-light-blocking-glasses-the-creator",
  "blue-light-blocking-glasses-lover",
];

// Function to handle each collection
function handleCollection(collectionHandle, useColor) {
  const collectionParent = document.querySelector(
    `[data-collection-handle="${collectionHandle}"]`
  );

  if (!collectionParent) return; // Exit if the collection doesn't exist

  // Select all color divs within the products grid
  const colorDivs = collectionParent.querySelectorAll(
    "[data-product-grid-item] [data-color]"
  );

  let selectedImage = null; // To store the `data-variant-image` for the selected color

  colorDivs.forEach((colorDiv) => {
    // Get the value of the data-color attribute
    const colorValue = colorDiv.getAttribute("data-color");

    // Check if the color matches the desired color (rosa or orange skies)
    if (colorValue === useColor) {
      // Get the image from the `data-variant-image` attribute
      selectedImage = colorDiv.getAttribute("data-variant-image");
    }

    // Check if the color is not 'Rosa' or 'Orange skies'
    if (colorValue !== "rosa" && colorValue !== "orange skies") {
      // Hide the color div by setting `display: none`
      colorDiv.style.display = "none";

      // Alternatively, to remove the color div entirely:
      // colorDiv.remove();
    }
  });

  // If a selected image was found, apply it to `.image-wrapper img` within `.product-item`
  // if (selectedImage) {
  //   const productItems = collectionParent.querySelectorAll(".product-item");
  //   productItems.forEach((productItem) => {
  //     const imageWrapperImg = productItem.querySelector(".image-wrapper img");
  //     if (imageWrapperImg) {
  //       imageWrapperImg.removeAttribute("src"); // Remove existing src attribute
  //       imageWrapperImg.removeAttribute("srcset"); // Remove existing srcset attribute
  //       imageWrapperImg.src = selectedImage; // Update the `src` attribute
  //       imageWrapperImg.srcset = selectedImage; // Update the `srcset` attribute
  //     }
  //   });
  // }
  const productItems = collectionParent.querySelectorAll(".product-item");
    productItems.forEach((productItem, index) => {
      if (index === 0) return;
      console.log(useColor)
      // debugger;
      const selectedColor =  productItem.querySelector('[data-color="'+ useColor +'"]');
      if(selectedColor){
        const imageWrapperImg = productItem.querySelector(".image-wrapper img");
        const link_color = selectedColor.getAttribute("data-href");
        // debugger;
        if(link_color){
          productItem.querySelectorAll('a').forEach(a=>{
               a.href = link_color;
             
          })
        }
        
        if (imageWrapperImg) {
          selectedImage = selectedColor.getAttribute("data-variant-image");
          imageWrapperImg.removeAttribute("src"); // Remove existing src attribute
          imageWrapperImg.removeAttribute("srcset"); // Remove existing srcset attribute
          imageWrapperImg.src = selectedImage; // Update the `src` attribute
          imageWrapperImg.srcset = selectedImage; // Update the `srcset` attribute
        }
      }
      
    });

  // Select all anchor tags inside the product grid items
  const anchorTags = collectionParent.querySelectorAll(
    "[data-product-grid-item] a"
  );

  anchorTags.forEach((anchor) => {
    anchor.addEventListener("click", function (event) {
      // Prevent default behavior of the anchor tag
      event.preventDefault();

      // const originalUrl = location.origin + this.closest('.product-item').querySelector('[data-color="rosa"]').getAttribute('data-href');
      // debugger;
      // Get the current URL from the href attribute
      const originalUrl = anchor.href;

      // Append the query parameter `view=blue-light-blocking-glasses`
      const url = new URL(originalUrl);
      url.searchParams.set("view", "blue-light-blocking-glasses");

      // Redirect to the modified URL
      window.location.href = url.toString();
    });
  });
}

// Loop through each collection handle and apply the function
collectionHandles.forEach((handle, index) => {
  // Alternate between "rosa" and "orange skies" based on the index
  const useColor = index % 2 === 0 ? "rosa" : "orange skies";
  handleCollection(handle, useColor);
});


// Array of colors to use based on index
const naturalColors = [
  // "rose",          // Index 0
  "la vie en rose", // Index 1
  "purple haze",   // Index 2
     // Index 3
  "pop orange" ,    // Index 4
  "baja orange",
];

// Function to handle each collection
function handleNaturalCollection(collectionHandle, useColor) {
  const collectionParent = document.querySelector(
    `[data-collection-handle="${collectionHandle}"]`
  );

  if (!collectionParent) return; // Exit if the collection doesn't exist

  // Select all color divs within the products grid
  const colorDivs = collectionParent.querySelectorAll(
    "[data-product-grid-item] [data-color]"
  );

  let selectedImage = null;
  colorDivs.forEach((colorDiv) => {
    // Get the value of the data-color attribute
    const colorValue = colorDiv.getAttribute("data-color");

    if (colorValue === useColor) {
      // Get the image from the `data-variant-image` attribute
      selectedImage = colorDiv.getAttribute("data-variant-image");
    }

    // Check if the color is not in the specified colors
    if (
      colorValue !== "rose" &&
      colorValue !== "la vie en rose" &&
      colorValue !== "purple haze" &&
      colorValue !== "baja orange" &&
      colorValue !== "pop orange"
    ) {
      // Hide the color div by setting `display: none`
      colorDiv.style.display = "none";

      // Alternatively, to remove the color div entirely:
      // colorDiv.remove();
    }
  });

  // If a selected image was found, apply it to `.image-wrapper img` within `.product-item`
  // if (selectedImage) {
    const productItems = collectionParent.querySelectorAll(".product-item");
    productItems.forEach((productItem, index) => {
      if (index === 0) return;
      console.log(useColor)
      // debugger;
      const selectedColor =  productItem.querySelector('[data-color="'+ useColor +'"]');
      if(selectedColor){
        const link_color = selectedColor.getAttribute("data-href");
        debugger;
        if(link_color){
          productItem.querySelectorAll('a').forEach(a=>{
               a.href = link_color;
             
          })
        }
        const imageWrapperImg = productItem.querySelector(".image-wrapper img");
        if (imageWrapperImg) {
          selectedImage = selectedColor.getAttribute("data-variant-image");
          imageWrapperImg.removeAttribute("src"); // Remove existing src attribute
          imageWrapperImg.removeAttribute("srcset"); // Remove existing srcset attribute
          imageWrapperImg.src = selectedImage; // Update the `src` attribute
          imageWrapperImg.srcset = selectedImage; // Update the `srcset` attribute
        }
      }
      
    });
  // }

  // Select all anchor tags inside the product grid items
  const anchorTags = collectionParent.querySelectorAll(
    "[data-product-grid-item] a"
  );

  anchorTags.forEach((anchor) => {
    anchor.addEventListener("click", function (event) {
      // Prevent default behavior of the anchor tag
      event.preventDefault();

      // Get the current URL from the href attribute
      const originalUrl = anchor.href;
      // const originalUrl = location.origin + this.closest('.product-item').querySelector('[data-color="la vie en rose"]').getAttribute('data-href');

      // Append the query parameter `view=natural-blue-light-filters`
      const url = new URL(originalUrl);
      url.searchParams.set("view", "natural-blue-light-filters");

      // Redirect to the modified URL
      window.location.href = url.toString();
    });
  });
}

// Array of collection handles
const collectionNaturalHandles = [
  "natural-blue-light-filters-1",
  "natural-blue-light-filters-lover",
  "natural-blue-light-filters-the-creator",
  "natural-blue-light-filters-lover-1"
];

// Loop through each collection handle and apply the function
collectionNaturalHandles.forEach((handle, index) => {
  // Get the color based on the index, cycling through the colors if necessary
  const useColor = naturalColors[index % naturalColors.length];
  handleNaturalCollection(handle, useColor);
});
  // Select the div with the data-collection attribute
    const collectionDiv = document.querySelector('[data-collection="olivelo"]');

    if (collectionDiv) {
        // Select all elements with the data-color attribute inside collectionDiv
        const colorDivs = collectionDiv.querySelectorAll('[data-color]');

        colorDivs.forEach(div => {
            // Hide all colors except "olivelo"
            if (div.getAttribute("data-color") !== "olivelo") {
                div.style.display = "none";
            }
          else{
             div.dispatchEvent(new Event('mouseenter', { bubbles: true }));
          }
        });
    }
  if(location.pathname == "/pages/readers"){
    let cDiv = document.querySelectorAll('[data-color]');
    cDiv.forEach(div => {
            // Hide all colors except "olivelo"
            if (div.getAttribute("data-color") == "olivelo") {
                div.style.display = "none";
            }
         
        });
  }
});
